import { Activity, Customer } from 'gung-standard';

export function indexCustomersById(customers: Customer[]): Map<string, Customer> {
  const customersById = new Map<string, Customer>();
  for (const customer of customers || []) {
    if (customer && customer.id) {
      customersById.set(customer.id, customer);
    }
  }
  return customersById;
}

export function joinCustomersOntoMeetings(meetings: Activity[], customers: Customer[]): Activity[] {
  const customersById = indexCustomersById(customers);
  console.log(customers.filter(x => !!x.extra).map(x => x.extra));
  return (meetings || []).map(meeting => ({
    ...meeting,
    extra: {
      ...meeting.extra,
      _customer: customersById.get(meeting.customerId)
    }
  }));
}
